import { useQueryClient } from "@tanstack/react-query";
import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { setCsrfToken } from "../api";
import { useUserContext } from "../contexts";
import Form from "./Form";
import AuthLayout from "./AuthLayout";

const fields = [
  {
    name: "Code",
    id: "code",
    type: "hidden",
  },
  {
    name: "Name",
    id: "name",
    type: "text",
    required: true,
  },
  {
    name: "Email",
    id: "email",
    type: "email",
    required: true,
  },
  {
    name: "Password",
    id: "password",
    type: "password",
    required: true,
  },
];

export default function AcceptInvite() {
  const { code } = useParams();
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  const { user } = useUserContext();

  useEffect(() => {
    if (user !== null) {
      navigate("/");
    }
  }, [user]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <AuthLayout
      heading="Accept Invite"
      message="Please enter your details to accept the invite."
    >
      <Form
        path="accept-invite"
        fields={fields}
        initialValues={{ code }}
        updateCache={false}
        submitCallback={(data) => {
          setCsrfToken(data.csrfToken);
          queryClient.setQueryData(["user"], data.user);
          queryClient.setQueryData(["families"], [data.family]);
          navigate("/");
        }}
      />
    </AuthLayout>
  );
}
